@if (mode === 'renderer') {
  <div class="card-dp-buttons justify-content-center">
    {{element.fields.buttonWidth}}

    <div
      (click)="btnClick($event, element.fields.buttonLink)"
      class="card-dp-btn"
      [ngStyle]="{
        color: element.fields.buttonColor,
        'place-self': element.fields.buttonAlign,
        'font-size.px': element.fields.buttonFontSize,
        'border-top-left-radius.px': element.fields.buttonBorderRadiusTop,
        'border-top-right-radius.px': element.fields.buttonBorderRadiusRight,
        'border-bottom-left-radius.px': element.fields.buttonBorderRadiusLeft,
        'border-bottom-right-radius.px': element.fields.buttonBorderRadiusBottom,
        'background-color': element.fields.buttonBackground,
        'margin-top.px': element.fields.buttonMarginTop,
        'margin-right.px': element.fields.buttonMarginRight,
        'margin-bottom.px': element.fields.buttonMarginBottom,
        'margin-left.px': element.fields.buttonMarginLeft,
        'padding-top.px': element.fields.buttonPaddingTop,
        'padding-right.px': element.fields.buttonPaddingRight,
        'padding-bottom.px': element.fields.buttonPaddingBottom,
        'padding-left.px': element.fields.buttonPaddingLeft,
        'text-align': element.fields.buttonTextAlign,
        width: element.fields.buttonUseFillWidth ? '100%' : element.fields.buttonWidth ? element.fields.buttonWidth + 'px' : null
      }"
    >
      <span class="d-inline-block w-100">
        @if (element.fields.translate) {
          {{ element.fields.buttonText.i18n?.[currentLang] }}
        } @else {
          @if (element.fields.buttonText.value) {
            {{ element.fields.buttonText.value | translate }}
          } @else {
            {{ element.fields.buttonText | translate }}
          }
        }
      </span>
    </div>
  </div>
}

@if (mode === 'editor') {
  <div class="editor">
    <lib-gung-tabset #ngbTab="gungTabset" justify="fill">
      <lib-gung-tab id="content">
        <ng-template libGungTabTitle>
          <div class="tab-title">
            <span>Content</span>
          </div>
        </ng-template>
        <ng-template libGungTabContent>
          <div class="row">
            <div class="col-12">
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [(ngModel)]="element.fields.translate"
                  id="translate"
                  (ngModelChange)="changeTranslate()"
                />
                <label class="form-check-label" for="translate">Translate</label>
              </div>
            </div>
            @if (element.fields.translate) {
              <lib-gung-accordion [closeOthers]="false">
                @for (lang of translateLangs; track lang) {
                  <lib-gung-accordion-item [collapsed]="true">
                    <ng-template libGungAccordionHeader>{{ lang.toUpperCase() }}</ng-template>
                    <ng-template libGungAccordionBody class="acc-body">
                      <div class="col-12 mb-2">
                        <lib-gung-text-input [gungTranslate]="'Button'" [(ngModel)]="element.fields.buttonText.i18n[lang]"/>
                      </div>
                    </ng-template>
                  </lib-gung-accordion-item>
                }
              </lib-gung-accordion>
            } @else {
              <div class="col-12">
                @if (element.fields.buttonText.value) {
                  <lib-gung-text-input
                    [gungTranslate]="'Button'"
                    [(ngModel)]="element.fields.buttonText.value"
                  ></lib-gung-text-input>
                } @else {
                  <lib-gung-text-input
                    [gungTranslate]="'Button'"
                    [(ngModel)]="element.fields.buttonText"
                  ></lib-gung-text-input>
                }
              </div>
            }
            <div class="col-12 mb-2">
              <lib-gung-text-input
                [gungTranslate]="'Button link'"
                [(ngModel)]="element.fields.buttonLink"
              ></lib-gung-text-input>
            </div>
          </div>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab id="styles">
        <ng-template libGungTabTitle>
          <div class="tab-title">
            <span>Styles</span>
          </div>
        </ng-template>
        <ng-template libGungTabContent>
          <div class="row">
            <div class="col-12">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" [(ngModel)]="element.fields.buttonUseFillWidth" id="fillWidth"/>
                <label class="form-check-label" for="fillWidth">USE_FILL_WIDTH</label>
              </div>
            </div>
            @if (!element.fields.buttonUseFillWidth) {
              <div class="col-12">
                <lib-gung-number-input
                  [gungTranslate]="'Width'"
                  [(ngModel)]="element.fields.buttonWidth"
                ></lib-gung-number-input>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <label>Align button</label>
                  <div class="d-flex">
                    <button
                      class="btn btn-sm btn-outline-secondary"
                      [class.align-active]="element.fields.buttonAlign === 'start'"
                      (click)="element.fields.buttonAlign = 'start'"
                    >
                      <i class="fa-solid fa-align-left"></i>
                    </button>
                    <button
                      class="btn btn-sm btn-outline-secondary"
                      [class.align-active]="element.fields.buttonAlign === 'center'"
                      (click)="element.fields.buttonAlign = 'center'"
                    >
                      <i class="fa-solid fa-align-center"></i>
                    </button>
                    <button
                      class="btn btn-sm btn-outline-secondary"
                      [class.align-active]="element.fields.buttonAlign === 'end'"
                      (click)="element.fields.buttonAlign = 'end'"
                    >
                      <i class="fa-solid fa-align-right"></i>
                    </button>
                  </div>
                </div>
              </div>
            }
            <div class="col-12">
              <lib-dynamic-page-general-field-styles
                [(fontSize)]="element.fields.buttonFontSize"
                [(color)]="element.fields.buttonColor"
                [(align)]="element.fields.buttonTextAlign"
              ></lib-dynamic-page-general-field-styles>
            </div>
            <div class="col-12">
              <label>Border radius (top right bottom left)</label>
              <div class="d-flex">
                <lib-gung-number-input
                  suppressLabel="true"
                  [(ngModel)]="element.fields.buttonBorderRadiusTop"
                ></lib-gung-number-input>

                <lib-gung-number-input
                  suppressLabel="true"
                  [(ngModel)]="element.fields.buttonBorderRadiusRight"
                ></lib-gung-number-input>

                <lib-gung-number-input
                  suppressLabel="true"
                  [(ngModel)]="element.fields.buttonBorderRadiusLeft"
                ></lib-gung-number-input>

                <lib-gung-number-input
                  suppressLabel="true"
                  [(ngModel)]="element.fields.buttonBorderRadiusBottom"
                ></lib-gung-number-input>
              </div>
            </div>
            <div class="col-12">
              <div class="d-flex color-dp-input">
                <lib-gung-text-input
                  [gungTranslate]="'BACKGROUND'"
                  [(ngModel)]="element.fields.buttonBackground"
                ></lib-gung-text-input>
                <input class="input-color" type="color" [(ngModel)]="element.fields.buttonBackground" />
              </div>
            </div>
            <div class="col-12">
              <lib-dynamic-page-element-margin-padding
                [(marginTop)]="element.fields.buttonMarginTop"
                [(marginRight)]="element.fields.buttonMarginRight"
                [(marginBottom)]="element.fields.buttonMarginBottom"
                [(marginLeft)]="element.fields.buttonMarginLeft"
                [(paddingTop)]="element.fields.buttonPaddingTop"
                [(paddingRight)]="element.fields.buttonPaddingRight"
                [(paddingBottom)]="element.fields.buttonPaddingBottom"
                [(paddingLeft)]="element.fields.buttonPaddingLeft"
              ></lib-dynamic-page-element-margin-padding>
            </div>
          </div>
        </ng-template>
      </lib-gung-tab>
    </lib-gung-tabset>
  </div>
}

@if (mode === 'preview') {
  <div class="btn-preview">
    <div class="prev-btn">Button</div>
  </div>
}